import * as React from 'react';
import { isTouchScreenDevice } from 'utils/window';
import { withTheme } from 'styled-components';
import { Tooltip, TooltipProps } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import './Tooltip.css';
import { TooltipContentWrapper, TooltipContentArrow } from './Tooltip.styled';

interface TooltipElementProps extends TooltipProps {
  classNames?: string;
  children: React.ReactChild;
  tooltipTheme?: 'dark' | 'light' | 'transparent';
  templateTheme?: { [key: string]: any };
}

const TooltipElement = ({ ...props }: TooltipElementProps) => {
  const newProps: TooltipElementProps = props;
  newProps.html = (
    <TooltipContentWrapper
      className={newProps.classNames}
      templateTheme={newProps.theme}
      onMouseUp={e => e.stopPropagation()}
    >
      {props.html}
      {props.arrow && <TooltipContentArrow templateTheme={newProps.theme} />}
    </TooltipContentWrapper>
  );
  newProps.arrow = false;
  return (
    <Tooltip {...newProps} theme={newProps.tooltipTheme}>
      {newProps.children}
    </Tooltip>
  );
};

TooltipElement.defaultProps = {
  popperOptions: {
    modifiers: {
      preventOverflow: {
        boundariesElement: 'viewport'
      },
      computeStyle: { gpuAcceleration: false }
    },
    positionFixed: isTouchScreenDevice()
  },
  useContext: true,
  stickyDuration: 0,
  tooltipTheme: 'light',
  animateFill: false,
  arrow: false
};

export default withTheme(TooltipElement);
